
import Pagination from '@/components/Pagination.vue'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { joinParams } from '@/utils/index'
export default defineComponent({
    name: 'User',
    components: {Pagination},
    setup () {
        const { proxy } = getCurrentInstance() as any
        const router = useRouter()

        const state = reactive({
            filters: {
                keyword:    '', // 用户名
                group_id:   '', // 角色ID
                brand_name: '', // 品牌名
                channel_no: '', // 渠道名称
                limit:      10, // 每页条数
                page:       1,  // 当前页码
                user_type: ''   // 用户类型
            },
            total:          0,  // 总条数
            tableData:      [], // 表单数据
            groupList:      [], // 角色列表
        })
        
        // 获取用户列表
        const getUserList = ()=>{
            proxy.$http.get(`/admin/User/getUserList?${joinParams(state.filters)}`).then((res:any) => {
                const { code, data, msg, count } = res
                if(code != 0) {
                    return proxy.$message({ type:'error', message: msg })
                }
                state.tableData = data
                state.total = count || 0
            })
        }
        // 获取角色列表
        const getGroupList = () => {
            proxy.$http.get(`/admin/User/getGroupList`).then((res:any) => {
                const { code, data, msg } = res
                if (code != 0) {
                    return proxy.$message({ type:'error', message: msg })
                }
                state.groupList = data
            })
        }
        // 搜索
        const search = () => {
            state.filters.page = 1
            getUserList()
        }
        // 编辑
        const onEdit = (id:string) => {
            router.push('/permission/user/edit?id='+id)
        }
        // 更新状态
        const changeStatus = (row:any) => {
            const { id, status, username } = row
            proxy.$confirm(`确定要 ${status ? '禁用' : '开通'}${username} 吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                proxy.$http.get(`/admin/User/forbidden?id=${id}&status=${status^1}`).then(res => {
                    const { code, msg } = res
                    if (code != 0) {
                        return proxy.$message({ type: 'error', message: msg });
                    }
                    proxy.$message({ type: 'success', message: '操作成功' })
                    getUserList()
                })
            }).catch(() => {
                console.log('取消操作')
            })
        }
        // 翻页
        const onPageChange = (val:number) => {
            state.filters.page = val
            getUserList()
        }
        const onSizeChange = (val:number) => {
            state.filters.limit = val
            getUserList()
        }
        
        getGroupList() // 获取角色列表，用于搜索
        getUserList()
        return { ...toRefs(state), search, onEdit, changeStatus,  onPageChange,onSizeChange }
    }
})
